import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, RotateCcw } from "lucide-react";
import PageShell from "@/components/layout/PageShell";
import RobustAssessmentProfileView from "@/components/assessment/RobustAssessmentProfileView";
import RobustAssessmentPdfButton from "@/components/assessment/RobustAssessmentPdfButton";

const RobustAssessmentResults = ({ answers, profile, onRetake }) => {
  return (
    <PageShell>
      <section className="relative overflow-hidden pb-24 pt-24 forr-canvas sm:pt-32">
        <div className="pointer-events-none absolute -top-48 left-1/2 h-[900px] w-[900px] -translate-x-1/2 opacity-55 forr-radial-teal" />
        <div className="relative mx-auto max-w-[1120px] px-5 sm:px-10">
          <div className="mb-7 flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="forr-overline">Assessment updated</div>
              <p className="mt-2 text-sm forr-text-soft">
                This version is now your active baseline. Earlier assessments remain in history.
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              <RobustAssessmentPdfButton answers={answers} profile={profile} />
              <button
                type="button"
                onClick={onRetake}
                className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm forr-btn-secondary"
              >
                <RotateCcw size={15} /> Take another assessment
              </button>
            </div>
          </div>

          <div className="rounded-[28px] p-1">
            <RobustAssessmentProfileView answers={answers} profile={profile} />
          </div>

          <div className="mt-7 flex flex-wrap gap-3 rounded-[24px] p-5 forr-panel-action sm:p-6">
            <div className="min-w-0 flex-1">
              <div className="forr-overline">Continue in APOS Companion</div>
              <h2 className="mt-2 font-display text-2xl forr-text-ink">
                Use this baseline for current nervous-system state matching
              </h2>
              <p className="mt-2 max-w-3xl text-sm leading-relaxed forr-text-soft">
                Open the Companion, complete a current nervous-system check-in, and add full sports, workouts, programs, coaching, rehabilitation, and other scheduled demands in Plan.
              </p>
            </div>
            <Link
              to="/app"
              className="inline-flex shrink-0 items-center gap-2 self-center rounded-full px-6 py-3 text-sm font-medium forr-btn-primary"
            >
              Open APOS Companion <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default RobustAssessmentResults;
